<template>
  <div class="w-100 portions-configuration">
    <configuration-section-header
      class="my-0"
      :section-icon="'icon-block'"
      :section-title="$tc('configuration.sections.portion', 2)"
      :show-display-options="false"
    >
      <b-button
        v-tooltip="$t('configuration.actions.activate')"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
      >
        <i
          class="far fa-check-circle"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-tooltip="$t('configuration.actions.deactivate')"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
      >
        <i
          class="far fa-times-circle"
          aria-hidden="true"
        />
      </b-button>
      <div
        style="width:1px; height:18px; background: #d0d0d0"
        class="mx-3 line-separator2"
      />
      <b-button
        id="pop2-configuration-shortcuts"
        v-tooltip="$t('global.helpKey')"
        class="sq-btn py-1"
      >
        <i
          class="helpbtn far fa-keyboard mx-1"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        id="pop2-configuration-voice"
        v-tooltip="$t('global.helpVoice')"
        class="sq-btn py-1"
      >
        <i
          class="helpbtn far fa-comment mx-1"
          aria-hidden="true"
        />
      </b-button>
      <b-popover
        target="pop2-configuration-shortcuts"
        placement="bottom"
        triggers="click blur"
      >
        <div class="pop-help">
          <h3 class="text-center alt-primary">
            {{ $t('global.shortcuts') }}
          </h3>
          <hr class="py-0">
          <div class="d-flex mb-3">
            <div class="mr-2 px-1">
              <span class="shortcut px-2 py-1">Alt</span>+<span class="shortcut px-2 py-1"><i
                style="transform: rotate(90deg);"
                class="fal fa-level-down"
                aria-hidden="true"
              /></span>
            </div>
            <div>{{ $t('configuration.shortcuts.activateAll') }}</div>
          </div>
          <div class="d-flex mb-3">
            <div class="mr-2 px-1">
              <span class="shortcut px-2 py-1">Alt</span>+<span class="shortcut px-2 py-1">{{ $t('configuration.shortcuts.delKey') }}</span>
            </div>
            <div>{{ $t('configuration.shortcuts.deactivateAll') }}</div>
          </div>
        </div>
      </b-popover>
      <b-popover
        target="pop2-configuration-voice"
        placement="bottom"
        triggers="click blur"
      >
        <div class="pop-help">
          <h3 class="text-center alt-primary">
            {{ $t('global.voiceCommands') }}
          </h3>
          <hr class="py-0">
          <div class="d-flex mb-3 px-2">
            <div class="mr-2 px-1">
              <i
                class="alt-primary far fa-comment-dots"
                aria-hidden="true"
              />
            </div>
            <div>{{ $t('configuration.shortcuts.activateAll') }}</div>
          </div>
          <div class="d-flex mb-3 px-2">
            <div class="mr-2 px-1">
              <i
                class="alt-primary far fa-comment-dots"
                aria-hidden="true"
              />
            </div>
            <div>{{ $t('configuration.shortcuts.deactivateAll') }}</div>
          </div>
        </div>
      </b-popover>
    </configuration-section-header>
    <div class="mt-2 configuration-box">
      <div
        v-for="(portion, index) in portions"
        :key="index"
        class="element-row d-flex justify-content-between align-items-center py-3 px-4"
      >
        <div>
          <span class="element-name">{{ portion.name }}</span>
        </div>
        <div class="d-flex align-items-center">
          <div class="switch-btn p-0 d-flex align-items-center">
            <!-- TODO: Que el switch alterne el label "Activo" y "Desactivo" cuando se le dé funcionamiento -->
            <span class="mr-2">{{ $t('configuration.actions.active') }}</span>
            <input
              id="toggle"
              type="checkbox"
              class="offscreen"
              aria-hidden="true"
            >
            <label
              for="toggle"
              class="switch mb-0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader'

export default {
    name: 'SamplesMorphologyGrid',
    components: {
        ConfigurationSectionHeader
    },
    data() {
        return {
            actionTitle: null,
            portions: [
                { name: 'Bloque de parafina' },
                { name: 'Bloque congelado' },
                { name: 'Bloque M.E.' },
                { name: 'Bloque Metacrilato' },
                { name: 'Tubo Microcentrífuga' }
            ]
        }
    }
}
</script>

<style lang="scss">
.portions-configuration .line-separator,
.portions-configuration #pop-configuration-shortcuts,
.portions-configuration #pop-configuration-voice {
    display: none;
}
.portions-configuration .element-row {
    border-bottom: 1px solid vt-color(card-border);
}
.portions-configuration .element-row:hover {
    background: vt-color(light-primary);
}
.portions-configuration .element-row .element-name {
    color: vt-color(dark-text);
}
</style>
